import { RefObject, useEffect } from 'react';
import type { Maybe } from '@sso/common-types';

export default function useRemoveDisabledAddReadOnlyAttrs(disabled: Maybe<boolean>, ref: RefObject<HTMLInputElement>) {
  useEffect(() => {
    if (typeof ref === 'object' && ref?.current != null) {
      const el = ref.current;
      if (disabled === true) {
        el.setAttribute('readonly', '');
        el.removeAttribute('disabled');
      } else {
        el.removeAttribute('readonly');
      }
    }
  }, [ref, disabled]);
}
